module.exports = __webpack_public_path__ + "static/media/conversation.f9532057.svg";